import axios from 'axios'
import { parseApiError } from '@/shared/lib/parseApiError'

export const http = axios.create({
  baseURL: '/api',
  timeout: 15000,
  withCredentials: true
})

http.interceptors.response.use(
  response => response,
  error => Promise.reject(parseApiError(error))
)

export default http